import rights from '../../../../components/rights';
import ganttFilterHelper from '$$helpers/gantt_filter';

class Filter {
  constructor() {
    this.range = null;
    this.ganttInstance = null;
  }

  init(instance, config) {
    this.ganttInstance = instance;
    this.range = config.range;
  }

  _getFilterState() {
    const filterState = this.ganttInstance.ganttDataApi.getCurrentFilter()?.properties;

    const result = { ...filterState };

    if (result.assignee?.length) {
      result.assignee = [...result.assignee];
      result.assignee = result.assignee.map(resourceId => (resourceId === '-1' ? 'unassigned' : +resourceId || 'unassigned'));
    }

    return result;
  }

  isActive() {
    return this.ganttInstance.ganttDataApi.isFilterActive();
  }

  isFilteredByProjects() {
    const filterState = this._getFilterState();

    return !!filterState.gantt_id?.length;
  }

  isFilteredByUnassigned() {
    const filterState = this._getFilterState();

    return !!filterState.assignee.includes('unassigned') || !filterState.assignee.length;
  }

  filterProjects(projectIds) {
    const filterState = this._getFilterState();

    return filterState.gantt_id?.length ? filterState.gantt_id : projectIds;
  }

  filterResources(resources) {
    let filtredResources = [];
    const filterState = this._getFilterState();

    // rights filtration
    filtredResources = resources.filter(resource => resource.resourceProjects?.some(project => rights.project.hasRight(project.projectId, 'workload')));

    if (filterState.assignee.length) {
      filtredResources = filtredResources.filter(resource => filterState.assignee.find(id => id === resource.id || String(resource.id).includes(id)));
    }

    return filtredResources;
  }

  filterTasks(tasks) {
    let filteredTasks = [];

    const options = this._getFilterState();

    delete options.assignee;
    delete options.gantt_id;

    const filterFunction = ganttFilterHelper.getFilter({
      options,
    }, null);

    filteredTasks = tasks.filter(filterFunction);

    return filteredTasks;
  }

  filterByRange() {
    return [];
  }
}

export default new Filter();
